export default __webpack_public_path__ + "static/media/Piezometer.8dc4e33d.jpeg";